import { BaseFeaturesAddon } from './base';
import { Overlay } from 'ol';
export var OverlayFeatureAddonMode;
(function (OverlayFeatureAddonMode) {
    OverlayFeatureAddonMode["HOVER"] = "hover";
})(OverlayFeatureAddonMode || (OverlayFeatureAddonMode = {}));
export class OverlayFeatureAddon extends BaseFeaturesAddon {
    constructor(options = {}) {
        options = {
            ...{
                mode: OverlayFeatureAddonMode.HOVER,
                render: ({ feature }) => {
                    return feature.getId() ?? '';
                },
            },
            ...options,
        };
        if (options.mode === OverlayFeatureAddonMode.HOVER) {
            options.eventInName = 'hover-in';
            options.eventOutName = 'hover-out';
        }
        super('overlay', options);
        this.element = null;
        this.overlay = null;
        this._event = null;
        this._eventIn = null;
        this._eventOut = null;
    }
    _handle(customFeatures) {
        super._handle(customFeatures);
        if (!this.customFeatures?.customMap) {
            throw new Error("Can't handle overlay features addon when custom map is not defined.");
        }
        this.element = $('<div data-app-map_overlay_item class="card p-2 shadow"></div>');
        this.element.hide();
        $('body').append(this.element);
        this.overlay = new Overlay({
            element: this.element[0],
            positioning: 'top-center',
            offset: [0, 8],
        });
        this.customFeatures.customMap.ol.addOverlay(this.overlay);
        this._event = ({ feature }) => { };
        this._eventIn = ({ feature }) => {
            if (this.element && this.overlay && this.options.render) {
                const html = this.options.render({ feature });
                if (!html) {
                    return;
                }
                this.element.html(html);
                this.element.show();
                this.overlay.setPosition(feature.getCenter());
            }
        };
        this._eventOut = () => {
            if (this.element) {
                this.element.hide();
            }
        };
        this.customFeatures.on(this.options.mode, this._event);
        this.customFeatures.on(this.options.eventInName, this._eventIn);
        this.customFeatures.on(this.options.eventOutName, this._eventOut);
    }
    _handleRemove() {
        if (this.customFeatures) {
            if (this._event) {
                this.customFeatures.off(this.options.mode, this._event);
            }
            if (this._eventIn) {
                this.customFeatures.off(this.options.eventInName, this._eventIn);
            }
            if (this._eventOut) {
                this.customFeatures.off(this.options.eventOutName, this._eventOut);
            }
        }
    }
}
